export const MODAL2_TYPES = {
  UPDATE_MODAL2_DATA: "UPDATE_MODAL2_DATA",
};

const initialState = {
  id: "infotext-modal2",
  title: "",
  isOpen: false,
  setIsOpen: () => {},
  content: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MODAL2_TYPES.UPDATE_MODAL2_DATA:
      // Fermer repart de l'état initial : sinon les boutons, le style ou
      // noClose d'une modale fuiraient dans la suivante qui ne les redéfinit
      // pas. Vaut pour toutes les fermetures, y compris celles des écrans.
      if (action.payload?.isOpen === false) {
        return { ...initialState, ...action.payload };
      }
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
